import React from "react";
import useQuantityAwareTranslation from "@Translation/hooks/useQuantityAwareTranslation";
import {useAppSelector} from "@Hooks/selector/useAppSelector";
import IconUserOutline from "@Icons/user/IconUserOutline";

interface TotalPassengersProps {
    className?: string,
    displayLabel?: boolean,
}

function TotalPassengers(props: TotalPassengersProps) {
    const {
        className = "gb--row gb--row-middle gb--row-end route--price-pax",
        displayLabel = false,
    } = props
    // @ts-ignore
    const total = useAppSelector((state) => state?.form.passengers.passengers)
    const passengerLabel = useQuantityAwareTranslation("form.passengers.count", total)

    return (
        <span className={className}>
            <IconUserOutline width="12" height="12"/>
            {total}
            {displayLabel && ` ${passengerLabel}`}
        </span>
    )
}

export default TotalPassengers;